<app-loader [mode]="'indeterminate'">
</app-loader>

 <router-outlet></router-outlet>